import React, { useState } from "react";
import PropTypes from "prop-types";
import CheckBox from "../../Form/Checkbox/Checkbox";

const CollapseList = ({ content, handleChange, selected, idx }) => {
  const [collapse, setCollapse] = useState(true);

  return (
    <li className={`list ${(collapse && "collapsed") || "expanded"}`}>
      <button
        onClick={() => {
          setCollapse(!collapse);
        }}
      >
        {content.label}
      </button>
      <ul>
        {content.list.map(item => {
          return (
            <li key={`${item.id}-${idx}`}>
              <CheckBox
                id={item.id}
                value={JSON.stringify(item)}
                checked={selected.includes(JSON.stringify(item))}
                onChange={handleChange}
                text={item.label}
              >
                {item.description && item.description}
              </CheckBox>
            </li>
          );
        })}
      </ul>
    </li>
  );
};

CollapseList.propTypes = {
  content: PropTypes.instanceOf(Object),
  handleChange: PropTypes.func,
  selected: PropTypes.instanceOf(Array),
  idx: PropTypes.number,
};

export default CollapseList;
